import { type KeyboardEvent, type ReactElement } from "react";
import { Box, Typography } from "@mui/material";
import { QuestionBooleanModel } from "survey-core";

type GlBooleanProps = {
  question: QuestionBooleanModel;
  isReadOnly?: boolean;
  onKeyDown?: (event: KeyboardEvent<HTMLDivElement>) => void;
};

const GlBoolean = ({
  question,
  isReadOnly = false,
  onKeyDown
}: GlBooleanProps): ReactElement => {
  const leftValue = question.swapOrder;
  const rightValue = !question.swapOrder;

  const options = [
    { value: leftValue, label: question.locLabelLeft.renderedHtml },
    { value: rightValue, label: question.locLabelRight.renderedHtml }
  ];

  const handleSelect = (value: boolean) => {
    if (isReadOnly || question.isReadOnly) return;
    question.booleanValue = value;
  };

  const isSelected = (value: boolean): boolean => question.booleanValue === value;

  return (
    <Box
      className="glboolean"
      onKeyDown={onKeyDown}
      role="group"
      aria-labelledby={question.a11y_input_ariaLabelledBy as string | undefined}
    >
      <Box className="glboolean__row">
        {options.map((option) => {
          const selected = isSelected(option.value);

          return (
            <Box
              key={String(option.value)}
              className={`glboolean__option${selected ? " glboolean__option--selected" : ""}`}
              component="button"
              type="button"
              disabled={isReadOnly || question.isReadOnly}
              aria-pressed={selected}
              onClick={() => handleSelect(option.value)}
            >
              {selected ? (
                <Box className="glboolean__check" aria-hidden="true" />
              ) : (
                <Box className="glboolean__radio" aria-hidden="true" />
              )}
              <Typography className="glboolean__label" component="span">
                {option.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default GlBoolean;
